import React from 'react';
import { IPaginationParams, IPaginationResponse } from 'src/models/interfaces/pagination';
import { Results } from 'src/types/IVehicle';
import GridItem from './gridItem';
import TablePagination from './pagination';
import { GridContainer, MessageTD, Table, TBody, TFoot, THead } from './styles';

interface IProps {
  data: IPaginationResponse<Results>;
  error: boolean;
  loading: boolean;
  params: IPaginationParams;
  mergeParams: (newParams: Partial<IPaginationParams>) => void;
}

const DataGrid = (props: IProps) => {
  const { data, error, loading, params, mergeParams } = props;

  const { total, results } = data || ({ total: 0, results: [] } as typeof data);


  return (
    <>
      <GridContainer>
        <Table>
          <THead>
            <tr>
              <th>Modelo</th>
              <th>Marca</th>
              <th>Km</th>
              <th>Valor Ofertado</th>
              <th>Valor FIPE</th>
              <th>Ano</th>
              <th>Placa</th>
              <th>Status</th>
            </tr>
          </THead>
          <TBody>
            {error ? (
              <tr>
                <MessageTD>Houve um erro ao obter os registros.</MessageTD>
              </tr>
            ) : loading ? (
              <tr>
                <MessageTD>Carregando...</MessageTD>
              </tr>
            ) : results.length > 0 ? (
              results.map(d => (
                <GridItem key={d.id} item={d} />
              ))
            ) : (
              <tr>
                <MessageTD>Nenhum registro encontrado.</MessageTD>
              </tr>
            )}
          </TBody>
          <TFoot>
            <tr>
              <TablePagination
                colSpan={30}
                total={total}
                disabled={loading}
                paginationParams={params}
                onChange={mergeParams}
              />
            </tr>
          </TFoot>
        </Table>
      </GridContainer>
    </>
  );
};

export default DataGrid;
